interface ProjectsIconProps {
  className?: string;
}

export function ProjectsIcon({ className }: ProjectsIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Beaker body: round bottom tapering to narrow neck */}
      <path d="M9 3h6v3l3 10a4 4 0 0 1-3.8 5H9.8A4 4 0 0 1 6 16L9 6V3z" />
      {/* Neck rim */}
      <line x1="8" y1="3" x2="16" y2="3" />
      {/* Liquid level inside beaker */}
      <path d="M7.5 14h9" />
      {/* Document corner fold at top-right */}
      <path d="M18 2v4h4" />
      <path d="M18 2l4 4" />
    </svg>
  );
}
